export const getToken = () => {
    const token = localStorage.getItem("token");
    if (token !== null) {
      return token;
    }
    return null;
  };